import { useQuery } from '@tanstack/react-query';
import { api } from '../client';

interface DashboardData {
  recentUploads: Array<{
    id: string;
    filename: string;
    status: string;
    created_at: string;
    marker_count?: number;
    tier?: string;
    summary?: string;
  }>;
  currentProtocol: {
    id: string;
    status: string;
    items: Array<{ name: string; dosage?: string; frequency?: string }>;
  } | null;
  profile: {
    first_name: string;
    health_goals: string[];
  } | null;
  pendingRecommendations: number;
}

export function useDashboard() {
  return useQuery<DashboardData>({
    queryKey: ['mr-dashboard'],
    queryFn: () => api.get<DashboardData>('/dashboard'),
  });
}
